module.exports = __webpack_public_path__ + "img/logo_light.05fa4634.svg";